/// <amd-module name="Feed/Legacy/Protocols/UPack/UPackClientTool" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import { FeedView } from "Feed/Common/Contracts/Feed";
import { IPackageProtocolClient } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { IUPackConnectToFeedPanelProps, UPackConnectToFeedPanel } from "Feed/Legacy/Protocols/UPack/UPackConnectToFeedPanel";
import { UPackGetPublishCommand } from "Feed/Legacy/Protocols/UPack/UPackConstants";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export class UPackClientTool implements IPackageProtocolClient {
    public readonly name = "Universal";
    private pageContext: IVssPageContext;
    private getPublishCommand: UPackGetPublishCommand;

    constructor(pageContext: IVssPageContext, getPublishCommand: UPackGetPublishCommand) {
        this.pageContext = pageContext;
        this.getPublishCommand = getPublishCommand;
    }

    public getConnectPanel(feed: Feed, feedViews: FeedView[], hubAction: HubAction): JSX.Element {
        return React.createElement(UPackConnectToFeedPanel, {
            pageContext: this.pageContext,
            feed,
            getPublishCommand: this.getPublishCommand,
            hubAction
        } as IUPackConnectToFeedPanelProps);
    }
}
